import styled from '@emotion/styled';
import { parseHTML } from '../../../../services/parseHTML';

import { replaceShortcodes } from '../../../../services/replaceShortcodes';

import React, { useContext } from 'react';

import { LoanCalculatorContext } from '../../context';

/** @type {React.FC<{ content: string }>} */
export const LoanCalculatorContent = ({ content = '' }) => {
    const { monthlySavings, newMonthlyCost, settings } = useContext(
        LoanCalculatorContext,
    );

    if (
        !settings ||
        !settings.mortgageRate ||
        !settings.downpaymentDefaultConsumer ||
        !settings.downpaymentDefaultMortgage ||
        !settings.consumerRate
    ) {
        throw Error('calculatorConfig is unavailable');
    }

    const {
        mortgageRate,
        downpaymentDefaultConsumer,
        downpaymentDefaultMortgage,
        consumerRate,
    } = settings;

    return content ? (
        <Content className="FactorOfferPopup__text">
            {parseHTML(
                replaceShortcodes(content, {
                    newMonthlyCost,
                    monthlySavings,
                    downpaymentDefaultMortgage,
                    mortgageRate,
                    downpaymentDefaultConsumer,
                    consumerRate,
                }),
                'markdown',
            )}
        </Content>
    ) : null;
};

const Content = styled.div`
    p {
        font-size: 18px;
    }

    .savings {
        font-size: 53px;
        font-family: inherit;
    }
`;
